import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import {
  MOTION_VAR_INITIAL,
  MOTION_VAR_ANIMATE,
  MOTION_VAR_EXIT,
  PAGE_ANIMATE_MODE,
  PAGE_ANIMATE_VARIANTS,
} from "@constants/Animation.constants.js";
import usePageTracking from "@hooks/usePageTracking.js";
import PageLayout from "@layouts/PageLayout";
import PageNoFooterLayout from "@layouts/PageNoFooterLayout";
import AuthRequiredPageLayout from "@layouts/AuthRequiredPageLayout";
import AuthRequiredOptionPageLayout from "@layouts/AuthRequiredOptionPageLayout";
import AuthPage from "@pages/AuthPage";
import HomePage from "@pages/HomePage";
import ProjectPage from "@pages/ProjectPage";
import OptionPage from "@pages/OptionPage/OptionPage";
import UnfoundPage from "@pages/UnfoundPage/UnfoundPage";

function AnimatedRoutes({ currentUserRole }) {
  const location = useLocation(); // Get current location

  usePageTracking("G-YPRE55R6VT");

  const handleProjectSelect = (project) => {
    localStorage.setItem("projectSelection", JSON.stringify(project));
  };

  const handleModelSelect = (model) => {
    localStorage.setItem("modelSelection", JSON.stringify(model));
  };

  return (
    <AnimatePresence mode={PAGE_ANIMATE_MODE}>
      <motion.div
        key={location.pathname} // Ensure animation triggers on route change
        initial={MOTION_VAR_INITIAL}
        animate={MOTION_VAR_ANIMATE}
        exit={MOTION_VAR_EXIT}
        variants={PAGE_ANIMATE_VARIANTS.variants}
        transition={PAGE_ANIMATE_VARIANTS.transition}
      >
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Navigate to="/home" replace />} />

          {/* Layout with Footer for pages that need it */}
          <Route element={<PageLayout />}>
            <Route
              path="/home/login"
              element={
                currentUserRole ? <Navigate to="/home" replace /> : <AuthPage />
              }
            />
          </Route>

          {/* Layout without Footer for the OptionPage */}
          <Route element={<PageNoFooterLayout />}></Route>

          {/* Protected Pages With Footer (Auth Required) */}
          <Route element={<AuthRequiredPageLayout />}>
            <Route
              path="/home"
              element={<HomePage onProjectSelect={handleProjectSelect} />}
            />
            <Route
              path="/home/:projectName"
              element={<ProjectPage onModelSelect={handleModelSelect} />}
            />
          </Route>

          {/* Option Page Layout (Auth Required) */}
          <Route element={<AuthRequiredOptionPageLayout />}>
            <Route
              path="/home/:selectedTab/:projectName/:modelName"
              element={<OptionPage onModelSelect={handleModelSelect} />}
            />
          </Route>

          {/* Fallback route */}
          <Route element={<PageLayout />}>
            <Route path="*" element={<UnfoundPage />} />
          </Route>
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
